import { render, staticRenderFns } from "./LoginAs.vue?vue&type=template&id=ba1c2b50&scoped=true"
import script from "./LoginAs.vue?vue&type=script&lang=js"
export * from "./LoginAs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1c2b50",
  null
  
)

export default component.exports